export default "__VITE_ASSET__CFyKp_Vn__"